/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "views/users/new-user/schemas/form";

const {
  formField: {
    firstName,
    lastName,
    username,
    email,
    password,
    repeatPassword,
    platforms,
    roles,
    permissions,
  },
} = checkout;

const initialValues = {
  [firstName.name]: "",
  [lastName.name]: "",
  [username.name]: "",
  [email.name]: "",
  [password.name]: "",
  [repeatPassword.name]: "",
  [platforms.name]: [],
  [roles.name]: 0,
  [permissions.name]: [],
};

export default initialValues;
